import IJsonResponse from "@/utils/types/IJsonResponse";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import StoreService from "@/store";
import HttpClient from "@/services/HttpClient";
import { IRate } from "../types";

@injectable()
export default class AnnouncementClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async getAnnouncement(): Promise<IJsonResponse> {
    const response = await this.http.get("/v1/app/announcements");
    this.store.commit("SellModule/setAnnouncement", response.data);
    return response;
  }
}
